import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import IFundDocuments from '../../interfaces/fund/documents/IFundDocuments';
import investmentFundDocumentsLang from '../../langs/investmentFundDocumentsLang';

const globalFilter = ['periodic_report', 'ampere_report', 'capital_call_and_distribution_notices', 'esg_reports'];

const mapFundTypes = [
	{
		tag: 'real_estate',
		documentTables: [
			{
				id: 'fund-documents-reports',
				name: investmentFundDocumentsLang.title_periodic_report_and_capital_calls.tag,
				filter: globalFilter,
				filterOpposite: false,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
			{
				id: 'fund-documents-documentations',
				name: investmentFundDocumentsLang.title_fund_documentation.tag,
				filter: globalFilter,
				filterOpposite: true,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
		],
	},
	{
		tag: 'private_credit',
		documentTables: [
			{
				id: 'fund-documents-reports',
				name: investmentFundDocumentsLang.title_periodic_report_and_capital_calls.tag,
				filter: globalFilter,
				filterOpposite: false,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
			{
				id: 'fund-documents-documentations',
				name: investmentFundDocumentsLang.title_fund_documentation.tag,
				filter: globalFilter,
				filterOpposite: true,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
		],
	},
	{
		tag: 'private_equity',
		documentTables: [
			{
				id: 'fund-documents-reports',
				name: investmentFundDocumentsLang.title_periodic_report_and_capital_calls.tag,
				filter: globalFilter,
				filterOpposite: false,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
			{
				id: 'fund-documents-documentations',
				name: investmentFundDocumentsLang.title_fund_documentation.tag,
				filter: globalFilter,
				filterOpposite: true,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
		],
	},
	{
		tag: 'venture_capital',
		documentTables: [
			{
				id: 'fund-documents-reports',
				name: investmentFundDocumentsLang.title_periodic_report_and_capital_calls.tag,
				filter: globalFilter,
				filterOpposite: false,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
			{
				id: 'fund-documents-documentations',
				name: investmentFundDocumentsLang.title_fund_documentation.tag,
				filter: globalFilter,
				filterOpposite: true,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
		],
	},
	{
		tag: 'listed_assets',
		documentTables: [
			{
				id: 'fund-documents-information',
				name: investmentFundDocumentsLang.title_information_documents.tag,
				filter: ['monthly_report', 'annual_report', 'periodic_report', 'general_communication'],
				filterOpposite: false,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
			{
				id: 'fund-documents-regulatory',
				name: investmentFundDocumentsLang.title_regulatory_documents.tag,
				filter: ['tax_legal_and_fund_rules', 'esg_reports'],
				filterOpposite: false,
				displayColumns: ['date', 'name', 'documentTypeName', 'id'],
			},
		],
	},
] as IFundDocuments[];

const useInvestFundDocuments = () => {
	const { t } = useTranslation();

	const result = useMemo<IFundDocuments[]>(
		() =>
			mapFundTypes.map((x) => ({
				...x,
				documentTables: x.documentTables.map((y) => ({ ...y, name: t(y.name) })),
			})),
		[t],
	);

	return result;
};

export default useInvestFundDocuments;
